import Button from '@atoms/Button/Button';
import CardTypeEnum from '@models/enums/CardTypeEnum';
import SiteEnum from '@models/enums/SiteEnum';
import { IColourSwatchCard } from '@models/IColourSwatchCard';
import { IImage } from '@models/IImage';
import { ILink } from '@models/ILink';
import AddToWishlist from '@molecules/AddToWishlist/AddToWishlist';
import DetailHeroInfo from '@molecules/DetailHeroInfo/DetailHeroInfo';

interface Props extends IColourSwatchCard {
  readonly mainImage: IImage;
  readonly findDealerCta: ILink;
  readonly productCta: ILink;
}

const ColourDetailInfo = ({
  colourCode,
  colourHexCode,
  colourName,
  description,
  findDealerCta,
  images,
  link,
  mainImage,
  productCta,
  wishlistDrawerLabels,
}: Props) => {
  const card = {
    colourCode,
    colourHexCode,
    colourName,
    description,
    images,
  };

  const WishlistButton = () => (
    <AddToWishlist
      isCard={false}
      card={card as IColourSwatchCard}
      cardId={link}
      collection={CardTypeEnum.Colours}
      wishlistDrawerLabels={wishlistDrawerLabels}
      buttonVariant="white"
    />
  );

  return (
    <DetailHeroInfo
      site={SiteEnum.Deco}
      variant="colour"
      colourHexCode={colourHexCode}
      trumpetText={colourCode}
      title={colourName}
      images={images}
      mainImage={mainImage}
      wishList={wishlistDrawerLabels && <WishlistButton />}
    >
      {description && (
        <div
          className="tw-font-sans tw-text-lg tw-font-light tw-text-black lg:tw-text-xl lg:first-letter:tw-mt-4"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {(productCta || findDealerCta) && (
        <div className="tw-flex tw-w-full tw-gap-xxs lg:tw-gap-xs">
          {productCta && (
            <Button
              buttonClasses={
                findDealerCta?.url ? 'tw-basis-6/12' : 'tw-basis-full'
              }
              as="link"
              href={productCta.url}
              variant="grey80"
              modifier="outline"
              label={productCta.text}
              target={productCta.target}
            />
          )}
          {findDealerCta && (
            <Button
              buttonClasses={
                productCta?.url ? 'tw-basis-6/12' : 'tw-basis-full'
              }
              as="link"
              href={findDealerCta.url}
              variant="grey80"
              modifier="fill"
              label={findDealerCta.text}
              target={findDealerCta.target}
            />
          )}
        </div>
      )}
    </DetailHeroInfo>
  );
};

export default ColourDetailInfo;
